export const obtenerDiasPromocion = ({fechaCheckIn, numNoches, diasPromo=[]}) => {


    if (!diasPromo || diasPromo.length === 0) {
        return 0;
    }

    let dia = new Date(fechaCheckIn).getDay()
    let arrDias = diasPromo.map((dia) => convertirDiaEnNumero(dia))

    let numDiasPromo = 0
    for (let i = 0; i <= numNoches; i++) {

        dia = dia + i
        if (dia > 6) {
            dia = dia - 7
        }

        if (arrDias.includes(i)) {
            numDiasPromo++
        }
    }

    return numDiasPromo

}

const convertirDiaEnNumero = (dia) => {

    switch (dia) {
        case 'Lunes':
            return 1
        case 'Martes':
            return 2
        case 'Miercoles':
            return 3
        case 'Jueves':
            return 4
        case 'Viernes':
            return 5
        case 'Sabado':
            return 6
        case 'Domingo':
            return 0
    }


}